import styles from "./bulkSelector.module.scss";
import { MdRefresh } from "react-icons/md";

interface IProps {
  onSelect: (i: number) => void;
  onSelectAll?: () => void; // NEW: For filter-based selection
  onReset: () => void;
  selected: number | null;
  totalInFilter?: number; // NEW: Total leads matching current filter
  isFilterMode?: boolean; // NEW: Are we in filter-based selection mode?
  className?: any;
}

const BulkSelector = ({
  onSelect,
  onSelectAll,
  onReset,
  selected,
  totalInFilter,
  isFilterMode = false,
  className
}: IProps) => {
  return (
    <div className={`${styles.bulk_container} ${className}`}>
      <div className={styles.button_group}>
        <button onClick={() => onSelect(25)}>Select next 25</button>
        <button onClick={() => onSelect(50)}>Next 50</button>
        {onSelectAll && totalInFilter !== undefined && (
          <button
            onClick={onSelectAll}
            className={isFilterMode ? styles.select_all_active : styles.select_all}
          >
            {isFilterMode ? (
              <>
                <span style={{ marginRight: '4px' }}>✓</span>
                All {totalInFilter}
              </>
            ) : (
              `Select All (${totalInFilter})`
            )}
          </button>
        )}
      </div>
      {isFilterMode ? (
        <span className={styles.filter_mode_message}>
          <span style={{ fontSize: '16px' }}>ℹ️</span>
          All {totalInFilter} leads matching current filters will be affected
        </span>
      ) : selected ? (
        <span className={styles.selected_count}>
          {selected} leads selected
        </span>
      ) : null}

      <button onClick={onReset} className={styles.reset_button}>
        <MdRefresh size={18} />
        Reset
      </button>
    </div>
  );
};

export default BulkSelector;
